import React from 'react';
import css from './qr.module.less';
import {
  Input, //ModalFooter
} from 'src/components/Antd';
// import QrReader from 'react-qr-reader';
import { Spin } from 'antd';
import { EScanType } from './index';
//import { modal } from '@/src/utils/Modal';
// import Test from './Test';
import { BrowserMultiFormatReader } from '@zxing/library';
import Camera from 'src/components/Webcam';
export { EScanType };
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const QRCodeCollection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    barcode,
    handleOnBarcodeChange, //barcodeError
    barcodeError,
    scanType,
    onScanTypeChange,
    onSubmit,
  } = props;

  return (
    <React.Fragment>
      <div className={css.container}>
        <div className={css.topContainer}>
          <div
            onClick={() => {
              onScanTypeChange(EScanType.Image);
            }}
            className={`${css.imageScanTitle} ${
              scanType === EScanType.Image ? css.selected : ''
            }`}>
            {getI18n(
              `allOrders.orderDetail.components_collection_QR_imagescan`,
            )}
          </div>

          <div
            onClick={() => {
              onScanTypeChange(EScanType.Barcode);
            }}
            className={`${css.barcodeTitle} ${
              scanType === EScanType.Barcode ? css.selected : ''
            }`}>
            {getI18n(
              `allOrders.orderDetail.components_collection_QR_barcodescan`,
            )}
          </div>
        </div>
        {scanType === EScanType.Barcode && (
          <Barcode
            error={barcodeError}
            value={barcode}
            onChange={handleOnBarcodeChange}
          />
        )}
        {scanType === EScanType.Image && <Image onSubmit={onSubmit} />}
      </div>
      {/* <ModalFooter onOk onCancel /> */}
    </React.Fragment>
  );
};

const Barcode = (props) => {
  const { value, onChange, error } = props;
  return (
    <div className={css.barCodeContainer}>
      <Input
        size='large'
        error={error}
        help={error}
        autoFocus={true}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default QRCodeCollection;

const Image = (props): React.ReactElement => {
  const videoConstraints = {
    width: { min: 500 },
    height: { min: 400 },
    aspectRatio: 1.25,
    facingMode: 'environment',
  };
  const { onSubmit } = props;
  const webcamRef = React.useRef(null);
  const captureRef = React.useRef(null);
  const codeReader = new BrowserMultiFormatReader();
  const [loading, setLoading] = React.useState(false);
  const capture = () => {
    //console.log('capture', capture);
    const imageSrc = webcamRef?.current?.getScreenshot();

    if (imageSrc) {
      codeReader
        .decodeFromImage(undefined, imageSrc)
        .then((result: any) => {
          // onUpdate(null, result);

          const { text } = result;
          if (text) {
            setLoading(true);
            clearInt();
          }

          // console.log('loading', loading);

          onSubmit(text, () => {
            setLoading(false);
            setInt();
          });
        })
        .catch((err) => {
          //if (loading) setLoading(false);
          // setLoading(false);
          // console.log('err', err);
          // onUpdate(err);
        });
    }
  };

  const setInt = () => {
    captureRef.current = setInterval(capture, 300);
  };

  const clearInt = () => {
    if (captureRef.current) clearInterval(captureRef.current);
  };

  React.useEffect(() => {
    setInt();
  }, []);

  return (
    <Spin spinning={loading}>
      <Camera
        videoConstraints={videoConstraints}
        width={500}
        screenshotFormat='image/jpeg'
        height={400}
        cameraRef={webcamRef}
        //onError={onCancel}
      />
    </Spin>
  );
};
